module.exports = __webpack_public_path__ + "static/logo_loony_bleu-63970966f84346df76a728733eb4c1de.png";